<template>
  <div class="modal" ref="modal" v-bind:class="{ 'is-active': is_active }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("tournament") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <form>
          <div class="title is-4">{{ $t("first tournament game") }}</div>
          <div class="columns">
            <div class="column is-one-third">
              <div class="field">
                <label class="label">{{ $t("date") }}</label>
                <div class="control">
                  <input class="input" type="date" v-model="meta.date" />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("number of players") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.number_of_players"
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="container" v-if="meta.number_of_players">
              <div class="grid is-col-min-10">
                <div
                  class="cell"
                  v-for="(player, pidx) in Number(meta.number_of_players)"
                >
                  <div class="title is-6">
                    {{ $t("player") }} {{ pidx + 1 }}
                  </div>
                  <div class="columns">
                    <div class="column">
                      <div class="field">
                        <label class="label">{{ $t("name") }}</label>
                        <div class="control">
                          <input
                            class="input"
                            type="text"
                            v-model="meta.players[pidx].name"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="column">
                      <div class="field">
                        <label class="label">{{ $t("score") }}</label>
                        <div class="control">
                          <input
                            class="input"
                            type="text"
                            v-model="meta.players[pidx].score"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="buttons">
          <button
            class="button is-primary is-rounded"
            @click="save"
            :disabled="is_form_invalid"
          >
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
          <button class="button is-rounded" @click="close_modal">
            <span class="icon">
              <i class="fa fa-close"></i>
            </span>
            <span>{{ $t("close") }}</span>
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import moment from "moment";
import GenericCalendar from "@/components/generic_calendar/Index.vue";

export default {
  name: "PokerTournamentModal",
  components: {
    GenericCalendar,
  },
  data() {
    return {
      is_active: false,
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.date || !v.meta.number_of_players;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.is_active = false;
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.is_active = true;
    },
    view_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/tournament/poker", { uuid: uuid })
        .then((tournament) => {
          console.log(tournament);
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      v.meta.settings = {};
      if (!v.meta.uuid)
        put("/tournament/poker", v.meta)
          .then(() => {
            v.$emit("success");
            v.is_active = false;
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/tournament/poker", v.meta)
          .then(() => {
            v.$emit("success");
            v.is_active = false;
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        players: [],
        number_of_players: 0,
      };
      v.error = "";
    },
  },
  mounted() {
    // let v = this;
  },
  watch: {
    "meta.number_of_players": function (val) {
      let v = this;

      let bkp = JSON.parse(JSON.stringify(v.meta.players));
      v.meta.players = [];

      for (let i = 0; i < val; i++) {
        let bk = bkp[i];
        v.meta.players.push(bk || { name: "", score: 0 });
      }
    },
  },
};
</script>
<style scoped>
/* .modal-card {
  width: 90%;
} */
</style>
